/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DatePipe } from "@angular/common";
import { EventEmiterService } from '@app/shared/services/event-emiter.service';

/**
 * Chat message component.
 */
@Component({
  selector: 'nb-chat-message-quote',
  template: `
    <p *ngIf="callLog" class="call-log-date">{{datePipe.transform(date, "M/d/yy")}}
      <span></span></p>
    <p [ngClass]="{'sender-call-quote' : callLog, 'sender': !callLog}" *ngIf="sender || date">
      <span>
        <span *ngIf="callLog" class="call-quote">{{ quote }}</span>
      </span>
      <time *ngIf="!callLog">{{ date  | date: dateFormat }}</time>
      <time *ngIf="callLog">{{ datePipe.transform(date, "h:mm a") }}</time>
    </p>
    <p class="quote" *ngIf="!callLog">
      {{ quote }}
    </p>
    <nb-chat-message-text [message]="message" (onDeleteMessage)="onDeleteMessage.emit($event)">
      {{ message }}
    </nb-chat-message-text>
  `,
  styleUrls: ['./chat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbChatMessageQuoteComponent implements AfterViewInit, OnChanges {

  /**
   * Message sender
   * @type {string}
   */
  @Input() message: string;

  /**
   * Message sender
   * @type {string}
   */
  @Input() sender: string;

  /**
   * Message send date
   * @type {Date}
   */
  @Input() date: Date;

  /**
    * Message send date format, default 'shortTime'
    * @type {string}
    */
  @Input() dateFormat: string = 'shortTime';

  /**
   * Quoted message
   * @type {Date}
   */
  @Input() quote: string;

  @Output() onDeleteMessage = new EventEmitter();
  @Input() callLog;
  @Input() messageId;

  constructor(public datePipe: DatePipe, private eventEmiterService: EventEmiterService) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.date.currentValue) {
      if (!this.eventEmiterService.realData[changes.date.currentValue.split('T')[0]]) {
        this.eventEmiterService.realData[changes.date.currentValue.split('T')[0]] = []
      }
      this.eventEmiterService.realData[changes.date.currentValue.split('T')[0]].push({
        message: this.message,
        sender: this.sender,
        date: this.date,
        dateFormat: this.dateFormat,
        quote: this.quote.includes('#') ? this.quote.split('#')[0] : this.quote,
        callLog: this.callLog,
        messageId: this.messageId
      })
      this.eventEmiterService.realData = Object.keys(this.eventEmiterService.realData).reduce((res, key) => (res[key] = this.eventEmiterService.realData[key].filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj["date"]).indexOf(obj["date"]) === pos
      }), res), {});
    }
  }

  ngAfterViewInit() {
    // console.log(this.messageId);
  }
  ngAfterContentInit() {

    const creatorObj = {

      "date": this.eventEmiterService.creatorData.date,
      "messageId": {
        "dateSent": this.eventEmiterService.creatorData.date,
      },
      "quote": this.eventEmiterService.creatorData.firstName + " " +
        this.eventEmiterService.creatorData.lastName + " " +
        this.eventEmiterService.creatorData.text + " " +
        "#" + (this.eventEmiterService.creatorData.recordId[2] ? this.eventEmiterService.creatorData.recordId[2] : this.eventEmiterService.creatorData.recordId[0]),
      "sender": this.eventEmiterService.creatorData.firstName + " " + this.eventEmiterService.creatorData.lastName

    }
    if (this.eventEmiterService.creatorData.date) {
      this.eventEmiterService.realData[this.eventEmiterService.creatorData.date.split('T')[0]] = [creatorObj]
    }
    this.eventEmiterService.realData = Object.keys(this.eventEmiterService.realData).sort().reduce((res, key) => (res[key] = this.eventEmiterService.realData[key], res), {});
  }

}
